

import Vue from "vue";
import IbDropdown from "@/components/Dropdown/Dropdown.vue";
import IbButton from "@/components/IBButton/IBButton.vue";
import IBDialogContainer from "@/components/IBDialog/IBDialogContainer.vue";
import IBDialogContainerProps from "@/components/IBDialog/mixins/IBDialogContainerProps";

export default Vue.extend({
	name: "IBModal",
	mixins: [
		IBDialogContainerProps
	],
	components: {
		IbDropdown,
		IbButton,
		IBDialogContainer
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ""
		},
		items: {
			type: Array,
			default: () => []
		},
		left: {
			type: Object,
			default: () => ({})
		},
		right: {
			type: Object,
			default: () => ({})
		},
		back: {
			type: String,
			default: ""
		},
		type: {
			type: String,
			default: "submit"
		}
	},
	computed: {
		rightIcon() {
			const { right = null } = this;

			return right ? right.icon : "";
		},
		leftIcon() {
			const { left = null } = this;

			return left ? left.icon : "";
		},
		active: {
			get(): boolean {
				return (<any>this).value;
			},
			set(v: boolean) {
				(<any>this).$emit('input', v);
			}
		}
	},
	methods: {
		openModal(idx: number) {
			this.$emit("openModal", idx);
		}
	}
});

